import styled from "styled-components";

export const Container = styled.div`
	min-height: var(--main-height);
	.top-content {
		display: flex;
		flex-direction: column;
		gap: 40px;
		h1 {
			font-size: 34px;
			color: var(--main-green);
		}
		p {
			width: 800px;
		}
	}

	.product-wrapper {
		max-width: 100%;
		margin: 0 20px;
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 40px;
		margin-bottom: 20px;

		.subinfo {
			p {
				text-align: justify;
			}

			ul p {
				text-align: justify;
			}
		}
	}

	.btn-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;

		a {
			text-align: center;
			background-color: var(--main-green);
			padding: 20px 100px;
			border-radius: 10px;
			color: white;
			font-weight: bold;
			font-size: 24px;
			transition: 600ms;
		}
		a:hover {
			scale: 1.02;
			-webkit-box-shadow: -1px -1px 41px 4px var(--light-green);
			-moz-box-shadow: -1px -1px 41px 4px var(--light-green);
			box-shadow: -1px -1px 41px 4px var(--light-green);
		}
		margin-bottom: 30px;
	}

	@media (max-width: 899px) {
		.top-content {
			max-width: 100vw;
			align-items: center;
			h1 {
				max-width: 90vw;
			}
			p {
				font-size: 14px;
				max-width: 90vw;
			}
		}
	}

	@media (max-width: 680px) {
		.top-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 40px;
			max-width: 100vw;
			h1 {
				font-size: 20px;
				max-width: 90vw;
			}
			p {
				font-size: 14px;
				max-width: 90vw;
			}
		}

		.btn-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;

			a {
				text-align: center;
				background-color: var(--main-green);
				padding: 20px 20px;
				border-radius: 10px;
				color: white;
				font-weight: bold;
				font-size: 18px;
				transition: 600ms;
			}
			a:hover {
				scale: 1.02;
				-webkit-box-shadow: -1px -1px 41px 4px var(--light-green);
				-moz-box-shadow: -1px -1px 41px 4px var(--light-green);
				box-shadow: -1px -1px 41px 4px var(--light-green);
			}
			margin-bottom: 30px;
		}
	}
	@media (max-width: 380px) {
		.product-wrapper {
			max-width: 100vw;
		}
	}
`;

export const Product = styled.div`
	max-width: 1060px;
	display: flex;
	justify-content: space-between;

	img {
		border-radius: 10px;
	}

	.title-wrapper {
		display: flex;
		align-items: center;
		gap: 10px;

		h2 {
			width: 100vw;
			font-size: 24px;
			white-space: normal;
		}

		svg {
			font-size: 24px;
			vertical-align: baseline;
			color: #80b38d;
			stroke: 3px;
		}
	}

	.info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 20px;
		max-width: 70%;

		.subinfo {
			display: flex;
			flex-direction: column;
			gap: 15px;

			li {
				list-style: disc;
			}
			ul {
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}
	}
	p {
		max-width: 600px;
	}

	@media (max-width: 680px) {
		max-width: 95vw;
		align-items: center;
		justify-content: flex-start;
		flex-direction: column;

		img {
			width: 100%;
			margin: 40px 0;
		}

		.info {
			width: 90vw;
			align-self: flex-start;
			p {
				font-size: 12px;
				width: 100%;
			}
			.title-wrapper {
				width: 90vw;
				text-align: left;
				justify-content: flex-start;
				h2 {
					width: 100%;
					font-size: 18px;
				}
				svg {
					font-size: 20px;
				}
			}

			.subinfo {
				width: 100%;
				p {
					width: 90vw;
					font-size: 14px;
					strong {
						font-size: 14px;
					}
				}

				h2 {
					width: 100%;
					font-size: 18px;
				}
				h4 {
					width: 100%;
					font-size: 14px;
				}

				ul {
					max-width: 100vw;
					li {
						width: 100%;
						font-size: 12px;
						max-width: 90vw;
					}
				}
			}
		}
	}

	@media (max-width: 380px) {
		max-width: 90vw;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
		}

		.info {
			width: 100%;
			p {
				font-size: 14px;
				strong {
					font-size: 14px;
				}
			}
			.title-wrapper {
				text-align: left;
				justify-content: flex-start;
				h2 {
					font-size: 18px;
				}
				svg {
					font-size: 20px;
				}
			}

			.subinfo {
				width: 90vw;
				p {
					font-size: 12px;
				}

				h2 {
					font-size: 18px;
				}
				h4 {
					font-size: 14px;
				}

				ul {
					max-width: 100vw;
					li {
						font-size: 12px;
						max-width: 80vw;
					}
				}
			}
		}
	}

	@media (min-width: 680px) {
		width: 100vw;
		justify-content: center;
		align-items: center;
		gap: 30px;

		.info {
			max-width: 800px;
			width: 60vw;
		}

		h2 {
			font-size: 20px;
		}
		.subinfo {
			max-width: 60vw;
		}
	}
`;

export const Wrapper = styled.div`
	max-width: 1200px;
	margin: 30px auto;
	display: flex;
	flex-direction: column;
	gap: 40px;

	@media (max-width: 680px) {
		margin: 0 auto;
		width: 100vw;
		align-items: center;
	}
`;
